import React from 'react'
import * as css from 'styles'
import styled from '@emotion/styled'
import { differenceInDays } from 'date-fns'

const NewArtistStickerWrapper = styled('div')({
  display: 'inline-block',
  background: css.color.blue,
  color: css.color.white,
  position: 'relative',
  // marginTop: '2em',
  // top: '4em',
  marginBottom: '1em',
  fontSize: '0.7em',
  lineHeight: '1em',
  padding: '8px 15px 5px',
  borderRadius: '1.5em',
  fontFamily: css.font.heading,
  textTransform: 'uppercase',

  [css.breakpoint.m_down]:{
    marginTop: 0,
    top: '-1em',
    fontSize: '0.6em',
    borderRadius: '1.5em',
  },
})

const NewArtistSticker = ({ user, style }) => {
  // if approved_at is before (today - 30 days)
  const today = new Date()
  const approvedAt = new Date(user.approved_at)
  const difference = differenceInDays(today, approvedAt)
  const show = difference < 30
  // console.log(user.slug, difference, show)

  return show ? (
    <NewArtistStickerWrapper style={style}>
      New
    </NewArtistStickerWrapper>
  ) : null
}

export default NewArtistSticker